import {DocUserField} from "../document-types";

export interface iWizzard{
    patchForm(value:DocUserField[]):void;
}

export const docCSS:string = `

@media print {
 table {
            width: 100%;
            border-collapse: collapse;
            margin: 0 auto;
        }

        thead {
            background-color: #cdcdcd;
            color: black;
            text-align: center;
        }

        .leftAlignHead {
            background-color: #cdcdcd;
            color: black;
            text-align: left;
        }

        th, td {
            border: 1px solid black;
            padding: 8px;
        }

        body {
            font-family: Arial, sans-serif;
            background-color: #ffffff;
            margin: 0;
            padding: 0;
        }

        .content-container {
            width: 95%;
            padding: 1.5cm 1cm 1.5cm 1cm;
        }

        h1 {
            font-size: x-large;
            text-align: center;
            font-weight: bold;
        }

        h4 {
            color: #8e8e8e;
            text-align: right;
            font-size: small;
            font-weight: bold;
        }

        .section {
            margin-bottom: 15px;
        }

        label {
            display: block;
            margin-bottom: 5px;
        }

        input {
            width: 100%;
            padding: 8px;
            border: 1px solid #ccc;
            border-radius: 4px;
        }
    }`;


export function getValueOfFieldWithName(fields: DocUserField[], name:string, documentID?:string){
    const field:DocUserField = fields.find(f => f.name == name && (documentID == null || f.userWarningId == documentID));
    if(field){
        return field.value;
    }
    return null;
}

export function getRawVal(val:any){
    if(val == "true" || val == "false"){
        return JSON.parse(val);
    }
    return val;
}
